import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./FlashSaleBanner.css";
import { FiCopy } from "react-icons/fi";

const FlashSaleBanner = () => {
    const couponCode = "GIFTFORHER";

    // countdown
    const [timeLeft, setTimeLeft] = useState(4 * 60 * 60);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (timeLeft <= 0) return;
        const interval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [timeLeft]);

    const hours = String(Math.floor(timeLeft / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0");
    const seconds = String(timeLeft % 60).padStart(2, "0");

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(couponCode);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (err) {
            console.error("Failed to copy code:", err);
        }
    };

    return (
        <motion.div
            className="flash-wrapper"
            initial="hidden"
            whileInView="visible"
            viewport={{
                once: false,   // ✅ animate EVERY time
                amount: 0.4,   // trigger when 40% visible
            }}
            variants={{
                hidden: { opacity: 0, y: 40 },
                visible: {
                    opacity: 1,
                    y: 0,
                    transition: {
                        duration: 0.6,
                        ease: "easeOut",
                    },
                },
            }}
        >
            <div className="flash-card">
                <button className="flash-strip">
                    <span>Special Offer</span>
                    <span className="flash-strip-close">✕</span>
                </button>

                <div className="flash-content">
                    <p className="flash-title">Flash Sale now on!</p>

                    <div className="flash-timer">
                        <div className="flash-time-block">
                            <span className="flash-time-value">{hours}</span>
                        </div>
                        <span className="flash-colon">:</span>
                        <div className="flash-time-block">
                            <span className="flash-time-value">{minutes}</span>
                        </div>
                        <span className="flash-colon">:</span>
                        <div className="flash-time-block">
                            <span className="flash-time-value">{seconds}</span>
                        </div>
                    </div>

                    <p className="flash-subtext">
                        Save on your favourite jewellery!
                        <br />
                        best sellers + more
                    </p>

                    {/* CTA + copy */}
                    <div className="flash-cta-row">
                        <button
                            className="flash-cta-with-copy"
                            onClick={handleCopy}
                        >
                            <span className="flash-cta-text">
                                Use Code: {couponCode}
                            </span>
                            <FiCopy className="flash-copy-icon-inside" />
                        </button>

                        {copied && (
                            <span className="flash-copied-label">
                                Copied!
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default FlashSaleBanner;
